import { toRgba } from 'color2k';
import get from 'lodash.get';

const getColor = ({ theme, color, colorMode }) => {
  const parsedColor = get(theme, `colors.${color}`, color);
  const semanticColor = get(theme, `semanticTokens.colors.${color}`, color);
  if (parsedColor === semanticColor) {
    return toRgba(color);
  }
  if (typeof semanticColor === "object") {
    return colorMode === "light" ? semanticColor["default"] : semanticColor["_dark"];
  }
  return parsedColor;
};

export { getColor };
